import Dexie from "dexie";
import { SafraSchema } from "./schemas";
import { migrationManager } from "./migrations/MigrationManager";

class AppDatabase extends Dexie {
  constructor() {
    super("ClienteRuralProjetos");

    this.version(1).stores({
      safras: SafraSchema
    });

    this.safras = this.table("safras");
  }

  async initialize() {
    await migrationManager.runMigrations(this);
    return this;
  }
}

export const db = new AppDatabase();
